import { ref, watch, onMounted } from "vue";
import LlSecondaryButton from "@/components/LlSecondaryButton.vue";
import { useDistributionStore } from "./store/useDistributionStore";
import { useDistributionNavigationStore } from "./store/useDistributionNavigationStore";
import DistributionStatusModal from "./modals/DistributionStatus.vue";
import UpdateDistributionModal from "./modals/UpdateDistributionModal.vue";
import Pagination from "@/components/Pagination.vue";
import Loader from "@/components/Loader.vue";
export default {
  name: "BillingDistribution",
  components: {
    Pagination,
    Loader,
    LlSecondaryButton,
    DistributionStatusModal,
    UpdateDistributionModal
  },
  props: {
    modalService: {
      type: Object,
      required: true
    },
    accountingService: {
      type: Object,
      required: true
    },
    userService: {
      type: Object,
      required: true
    }
  },
  setup() {
    const loading = ref(true);
    const distributionStore = useDistributionStore();
    const distributionNavigationStore = useDistributionNavigationStore();
    const distributionId = ref(undefined);
    const query = ref("");
    watch(() => query.value, () => distributionStore.searchDistribution(query.value));
    const getDistribution = async () => {
      loading.value = true;
      await distributionStore.listPaymentDistributions();
      await distributionStore.listAllDistributions();
      loading.value = false;
    };
    onMounted(() => {
      getDistribution();
    });
    query.value = distributionStore.distributionParms.search;
    const editDistribution = distribution => {
      distributionNavigationStore.toggleUpdateDistributionModal(true, distribution);
    };
    const openDistributionDetail = distribution => {
      distributionNavigationStore.openDistributionDetail("Details", distribution.id);
    };
    const showDistributionStatusModal = () => {
      distributionNavigationStore.toggleDistributionStatusModal(true);
    };
    return {
      query,
      loading,
      distributionId,
      editDistribution,
      distributionStore,
      openDistributionDetail,
      showDistributionStatusModal,
      distributionNavigationStore
    };
  }
};